import { TokenType } from 'src/shared/types';

let accessToken: string | undefined;

const getAccessToken = (): string | undefined => {
  return accessToken;
};

const getTokens = (): TokenType | undefined => {
  if (!accessToken) {
    return;
  }

  return {
    access_token: accessToken,
  };
};

const setTokens = (token: TokenType) => {
  accessToken = token.access_token;
};

const removeTokens = () => {
  accessToken = undefined;
};

const TokenService = {
  getTokens,
  getAccessToken,
  removeTokens,
  setTokens,
};

export default TokenService;
